export default __webpack_public_path__ + "static/media/dtt-api.e0574e41.png";